import { Box, Card, CardHeader } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import useLocales from "src/hooks/useLocales";

import LegendChart from "./LegendChart";
import useDataChart from "./useDataChart";
import useOptionsChart from "./useOptionsChart";

// ----------------------------------------------------------------------

export const ConnectionsStatusChart = () => {
	const { options } = useOptionsChart();
	const { series } = useDataChart();

	const { translate } = useLocales();

	return (
		<Card sx={{ pb: 3 }}>
			<CardHeader title={translate("overview.connections_by_status")} />
			<Box sx={{ mx: { sm: 1.5, xs: 0 }, mt: 4 }}>
				<ReactApexChart height={350} options={options} series={series} type='donut' />
			</Box>
			<LegendChart />
		</Card>
	);
};

export default ConnectionsStatusChart;
